// extracted by mini-css-extract-plugin
export default {"textArea":"approve-system-modal_textArea__rL8mu"};